module.exports = __webpack_public_path__ + "media/images/game/pages/ceska_mincovna-9c44a60bbe3650582d4c99e1c1b73d89.png";